module.exports = __webpack_public_path__ + "img/success3.c817b9eb.gif";